import { StyleTheme } from './theme.model';
import { ColorPipe } from './assets/color.pipe';
import { StyleService } from './assets/style.service';

export const normalizeTheme = (data: any): StyleTheme => {
  const colorPipe = new ColorPipe();
  const styleService = new StyleService(colorPipe);

  const theme: StyleTheme = {
    name: data.name,
    core: {
      common: {
        colors: {
          text: colorPipe.transform(data.core.common.colors.text),
          link: colorPipe.transform(data.theme.colors.primary),
          background: colorPipe.transform(data.core.common.colors.background),
        },
      },
      simpleCard: {
        colors: {
          background: colorPipe.transform(data.core.simpleCard.colors.background),
          backgroundTransparent: styleService.addTransparency(
            colorPipe.transform(data.core.simpleCard.colors.background),
          ),
        },
      },
    },
    theme: {
      colors: {
        primary: colorPipe.transform(data.theme.colors.primary),
        secondary: colorPipe.transform(data.theme.colors.secondary),
        success: colorPipe.transform(data.theme.colors.success),
        danger: colorPipe.transform(data.theme.colors.danger),
        warning: colorPipe.transform(data.theme.colors.warning),
        info: colorPipe.transform(data.theme.colors.info),

        light: {
          primary: styleService.adjustColor(colorPipe.transform(data.theme.colors.primary), -10),
          secondary: styleService.adjustColor(colorPipe.transform(data.theme.colors.secondary), -10),
          success: styleService.adjustColor(colorPipe.transform(data.theme.colors.success), -10),
          danger: styleService.adjustColor(colorPipe.transform(data.theme.colors.danger), -10),
          warning: styleService.adjustColor(colorPipe.transform(data.theme.colors.warning), -10),
          info: styleService.adjustColor(colorPipe.transform(data.theme.colors.info), -10),
        },

        dark: {
          primary: styleService.adjustColor(colorPipe.transform(data.theme.colors.primary), 10),
          secondary: styleService.adjustColor(colorPipe.transform(data.theme.colors.secondary), 10),
          success: styleService.adjustColor(colorPipe.transform(data.theme.colors.success), 10),
          danger: styleService.adjustColor(colorPipe.transform(data.theme.colors.danger), 10),
          warning: styleService.adjustColor(colorPipe.transform(data.theme.colors.warning), 10),
          info: styleService.adjustColor(colorPipe.transform(data.theme.colors.info), 10),
        },
      },
    },
  };

  return theme;
};
